var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmLengthLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.935,
    height: 343.532,
    viewBox: "0 0 14.935 343.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8931",
    "data-name": "Group 8931",
    transform: "translate(-1257.18 -491.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8964",
    "data-name": "Path 8964",
    d: "M0,0H342.532",
    transform: "translate(1264.646 492.3) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8965",
    "data-name": "Path 8965",
    d: "M0,0H13.935",
    transform: "translate(1271.614 834.831) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8966",
    "data-name": "Path 8966",
    d: "M0,0H13.935",
    transform: "translate(1271.614 492.3) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmLengthLine);
export default __webpack_public_path__ + "static/media/farmLengthLine.594fd7abb9bc6e10fad973e3a83ff925.svg";
export { ForwardRef as ReactComponent };